import Actions from "./components/Actions";
import AddDocuments from "./components/AddDocuments";
import SectionHeader from "../../components/SectionHeader";
import { Table } from "../../../../../../components/Functional";
import { Modal, Button } from "../../../../../../components/ui";
import { FETCH_INVOICE_DOCUMENTS } from "../../../../../../graphql/query/InvoiceDocument";
import useUser from "../../../../../../hooks/useUser";

const InvoiceDocuments = props => {
  const { invoiceId, invoice } = props || {};
  const { hasPermission } = useUser();

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "invoiceDocuments",
    headers: [
      { label: "File Name", name: "fileName", type: "label" },
      { label: "File Type", name: "fileType", type: "label" },
      { label: "Date", name: "updatedAt", type: "date" },
      { label: "", name: "action", type: "custom", component: Actions },
    ],
    inputs: [{ label: "Name", name: "name", type: "text", view: "partial" }],
    FETCH_QUERY: FETCH_INVOICE_DOCUMENTS,
    variables: {
      invoiceId: +invoiceId,
    },
    className: "sm:px-0 lg:px-0",
  };

  const modalProps = {
    body: AddDocuments,
    closeOnBackdrop: true,
    invoice,
    hideCloseButton: true,
    scale: "md",
    disabled: !hasPermission("UPDATE_INVOICE"),
  };

  const actions = [
    {
      component: () => {
        return (
          <Modal {...modalProps}>
            <Button
              label="Upload"
              action="black"
              disabled={!hasPermission("UPDATE_INVOICE")}
            />
          </Modal>
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Documents" actions={actions} />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default InvoiceDocuments;
